<template>
  <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.9533 15.0067H17.0067L23.66 21.6733L21.6733 23.66L15.0067 17.0067V15.9533L14.6467 15.58C13.1267 16.8867 11.1533 17.6733 9.00666 17.6733C4.22 17.6733 0.339996 13.7933 0.339996 9.00667C0.339996 4.22 4.22 0.340004 9.00666 0.340004C13.7933 0.340004 17.6733 4.22 17.6733 9.00667C17.6733 11.1533 16.8867 13.1267 15.58 14.6467L15.9533 15.0067ZM3.00666 9.00667C3.00666 12.3267 5.68666 15.0067 9.00666 15.0067C12.3267 15.0067 15.0067 12.3267 15.0067 9.00667C15.0067 5.68667 12.3267 3.00667 9.00666 3.00667C5.68666 3.00667 3.00666 5.68667 3.00666 9.00667Z"
    />
  </svg>
</template>
